import { Injectable, inject } from '@angular/core';

import { WindowRefService } from '../window-ref/window-ref.service';

import { StorageType } from './storage.service';

export type KeysToCleanup = string[] | true;

export type StorageConfig = [string, [KeysToCleanup, KeysToCleanup, string]][];

export type CleanupList = [string, KeysToCleanup, string][];

/**
 * Prepare the value to be stored in browser storage.
 * Convert `undefined` values to `null` for consistency
 */
export function prepareStorageValue(value: unknown): string | null {
  return value === undefined ? null : JSON.stringify(value);
}

export function getPrefixedKey(key: string, prefix: string): string {
  return prefix ? `${prefix}-${key}` : key;
}

export function getAllPrefixedKeys(storage: Storage, prefix: string): string[] {
  return storage && prefix ? Object.keys(storage).filter(key => key.startsWith(prefix)) : [];
}

/**
 * Filter StorageConfig by keys to be cleaned up either on logout or accountSwitch,
 * which is specified by the value index. Finally, remap the values to CleanupList.
 */
export function convertToCleanupList(config: StorageConfig, index: 0 | 1): CleanupList {
  return config.filter(([_, val]) => val[index]).map(([prefix, val]) => [prefix, val[index], val[2]]);
}

export const STORAGE_CLEANUP_CONFIG_KEY = 'hdms-storage-config';

@Injectable({
  providedIn: 'root'
})
export class StorageHelperService {
  private readonly win = inject(WindowRefService).nativeWindow;

  getStorage(type: StorageType): Storage {
    return this.win[type];
  }
}
